import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppTvImageSelector } from "src/_common/hooks/selectors/eventSelector";
import { removeEmptyObjectKey, removeTrailingZero, SOCKET_CHANNEL, SOCKET_URL, SOCKET_TRANSPORTS } from "src/_config";
import useSocket from 'use-socket.io-client';
import parse from 'html-react-parser'

export function RodeoTvImageComponent() {

    const eventApi = useEventApi()
    const tvImageSelector = useAppTvImageSelector()
    const { gameId } = useParams<any>();
    const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true)
    const [isShowingAdsPromotion, setIsShowingAdsPromotion] = useState<boolean>(false)
    const [adPromotionData, setAdPromotionData] = useState<any>(null)
    const [defaultAdsPromotionTime, setDefaultAdsPromotionTime] = useState<number>(1000)
    const toast = useToaster()
    const [tvImageData, setTvImageData] = useState<any>()
    const [socketData, setSocketData] = useState<any>()
    const [showWinnerText, setShowWinnerText] = useState<boolean>(false)

    const getLeaderboardDetails = () => {
      // if (location) {
      let params: any = { page: 1, perPage: 10 };
  
      eventApi.callViewLeaderBoard(
        params,
        (message: string, resp: any) => {
          if (resp) {
            console.log({resp})
            setTvImageData(resp)
          }
        },
        (message: string) => {
          toast.error(message);
        }
      );
      // }
    };

    const resetCssStyle = (type: any) => {
        var element = document.getElementById('rodeo_body');
        if (element) {
            if(["leaderboard","ad"].includes(type)) {
                element.style.padding = '0 30px'
                element.style.paddingTop = '2.5em'
            }
            else {
                element.style.padding = '0px'
            }
        }
    }

    //Socket Implementation start here
    const [socket] = useSocket(SOCKET_URL, {
        autoConnect: false,
        withCredentials: true,
        transports: SOCKET_TRANSPORTS,
        upgrade: true,        // Enable transport upgrades (polling -> websocket)
        rememberUpgrade: true, // Remember successful upgrades for faster reconnection
    });

    useEffect(() => {
        socket.connect()
        socket.on(SOCKET_CHANNEL.TV_BOARD_IMAGE, (tvImageData: any) => {
            console.log({tvImageData})
            setSocketData(tvImageData)
            setShowWinnerText(false)
            setIsShowingAdsPromotion(false)
            if (tvImageData.type == "landing-tv") {
                resetCssStyle("landing")
                setIsInitialLoad(true)
            } else {
                resetCssStyle("leaderboard")
                getLeaderboardDetails()
                setIsInitialLoad(false)
            }
        });

        socket.on(SOCKET_CHANNEL.ADV_PROMOTION, (adsPromotionData: any) => {
            console.log({adsPromotionData})

            resetCssStyle("ad")
            setShowWinnerText(false)
            setIsInitialLoad(false)
            setIsShowingAdsPromotion(true)
            setAdPromotionData(adsPromotionData)
            // setDefaultAdsPromotionTime(adsPromotionData.default_timeout)
        });

        socket.on(SOCKET_CHANNEL.WINNER_TEXT, (data: any) => {
            console.log({data})
            setSocketData(data)
            setIsInitialLoad(false)
            setIsShowingAdsPromotion(false)
            setShowWinnerText(true)
        });


        return () => {
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        // getTvImageDetails(gameId, null)
        // setIsInitialLoad(true)
        // var element = document.getElementById('root');
        // if (element) {
        //     element.style.top = '0px'
        //     element.style.position = 'absolute'
        // }
    }, [])

    return (
        <React.Fragment>
            {
                isInitialLoad ?
                    <div className="main-bg"
                        style={{
                            backgroundImage: `url("${'/images/tv/tv-screen-blank.jpg'}")`,
                            position: 'absolute',
                            top: '0px',
                            width: '100%',
                            height: '100%',
                            backgroundSize: '100% 100%',
                            backgroundRepeat: 'no-repeat'
                        }}
                    >

                    </div> :
                    <>
                        <div className="main-bg"
                            style={{ backgroundColor: '#000', position: 'fixed', width: '100%', height: '100%', left: 0, top: 0, zIndex: -1, overflowX: "hidden", margin: 0 }}
                        ></div>
                        <section className="container" style={{ maxWidth: '100%' }}>
                            <div className="logobar ">
                                <div className="border-div" />
                                <div className="border-div2" />
                                <div className="logo_left_txt">
                                    {/* {
                                        `${tvImageSelector && tvImageSelector.rodeo_event_dtls ? tvImageSelector.rodeo_event_dtls.title : '--'}${tvImageSelector && tvImageSelector.event_dtls && tvImageSelector.event_dtls.rodeo_pick_event ? " :: " + tvImageSelector.event_dtls.rodeo_pick_event.title : ''}`
                                    } */}
                                    {
                                        !isShowingAdsPromotion ? socketData?.game_info?.title : adPromotionData?.text ? adPromotionData?.text : "Ad Promotion"
                                    }
                                    {/* Leaderboard */}
                                </div>
                                <div className="logo_image"><img src="/images/tv/logo_.png" className="img-responsive" /></div>
                            </div>

                            {/* <div className="heading_text">
                                {
                                    tvImageSelector && tvImageSelector.event_dtls && tvImageSelector.event_dtls.sponsor ?
                                        `SPONSER BY ${tvImageSelector.event_dtls.sponsor.title}` : null
                                }
                            </div> */}
                            <div className="clearfix">
                                {
                                    !isShowingAdsPromotion && !showWinnerText ?
                                        <ul className="tv-list">
                                            {
                                                // tvImageData && tvImageData.list && tvImageData.list.data && tvImageData.list.data.length ?
                                                tvImageData && tvImageData.list && tvImageData.list.length ?
                                                    tvImageData.list.slice(0,10).map((item: any) => (
                                                        <li key={item.id}>
                                                            <div className="left_sec">
                                                                <div className="border-div"></div>
                                                                <div className="curve-bg">
                                                                    <div className="left_sec_l">
                                                                        {
                                                                            tvImageData?.leaderboard_setting?.leaderboard_display==1 ? 
                                                                                item?.user_dtls?.display_name || item?.user_dtls?.first_name || "- -"
                                                                            : item?.display_name || item?.first_name || "- -"
                                                                        }
                                                                    </div>
                                                                    <div className="left_sec_r">{item?.point ? Number(item.point).toFixed(2) : 0.0}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )) : <div className="text-center" style={{ color: '#fff' }}>
                                                        <p> No Result publish yet!</p>
                                                    </div>
                                            }
                                        </ul>
                                    :
                                        showWinnerText && socketData ?
                                            <>
                                                <div className="winner-text">
                                                    {socketData?.tvimage_winner_text ? parse(socketData?.tvimage_winner_text)  : ""}
                                                </div>
                                                <div className="circle-k">
                                                    {/* <img className="w-40" src="images/tv/circle_k.png" alt="image" /> */}
                                                    <img src={socketData?.circle_logo} className="w-40" />
                                                </div>
                                            </>
                                        :
                                            <div className="tv-ads-promotion">
                                                <img className="w-100" src={adPromotionData?.image} alt="image" />
                                            </div>
                                }

                            </div>
                        </section>
                    </>
            }


        </React.Fragment>
    )
}